import { combineReducers } from 'redux'
import {
  UPDATE_OTHER_PROJECT,
  UPDATE_OTHER_PROJECT_LIST,
  UPDATE_NVBUGS_ID,
  UPDATE_PAGE,
  CLEAR,
  UPDATE_REC_PROJECT_LIST,
  UPDATE_OPTION_SELECTED,
  FETCH_REC_PROJECT_LIST_START,
  FETCH_REC_PROJECT_LIST_SUCCESS,
  FETCH_REC_PROJECT_LIST_ERROR
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'

const otherProjectListReducer = createReducer([], {
  [UPDATE_OTHER_PROJECT_LIST]: (prev, { projectList }) => 
    Object.values(projectList).map((attrs) => {
      const {
        projectId,
        name,
        brand,
        partnerSiteName,
        hierarchyType
      } = attrs

      const hierarchyTypeCapitalized = hierarchyType.charAt(0).toUpperCase() + hierarchyType.slice(1)

      return {
        value: projectId,
        label: `${projectId} (${hierarchyTypeCapitalized}) (${name} | ${brand} | ${partnerSiteName})`
      }
  }),
  [CLEAR]: () => []
})

const otherProjectReducer = createReducer(null, {
  [UPDATE_OTHER_PROJECT]: (prev, { project }) => project,
  [CLEAR]: () => null
})

const nvbugsIdReducer = createReducer('', {
  [UPDATE_NVBUGS_ID]: (prev, { nvbugId }) => nvbugId,
  [CLEAR]: () => ''
})

const pageReducer = createReducer(1, {
  [UPDATE_PAGE]: (prev, { page }) => page,
  [CLEAR]: () => 1
})

const recProjectListReducer = createReducer([], {
  [UPDATE_REC_PROJECT_LIST]: (_, { projectList }) => projectList,
  [CLEAR]: () => []
})

const synopsisReducer = createReducer('', {
  [UPDATE_NVBUGS_ID]: (prev, { synopsis }) => synopsis,
  [CLEAR]: () => ''
})

const optionSelectedReducer = createReducer(null, {
  [UPDATE_OPTION_SELECTED]: (prev, { project }) => project,
  [UPDATE_OTHER_PROJECT]: () => 'other',
  [CLEAR]: () => ''
})

const recProjectListLoadingReducer = createReducer(false, {
  [FETCH_REC_PROJECT_LIST_START]: () => true,
  [FETCH_REC_PROJECT_LIST_SUCCESS]: () => false,
  [FETCH_REC_PROJECT_LIST_ERROR]: () => false,
})

export default combineReducers({
  nvbugId: nvbugsIdReducer,
  synopsis: synopsisReducer,
  page: pageReducer,
  recProjectList: recProjectListReducer,
  recProjectListLoading: recProjectListLoadingReducer,
  otherProject: otherProjectReducer,
  otherProjectList: otherProjectListReducer,
  optionSelected: optionSelectedReducer
})
